
export class LocalAppCallServiceRequest {
    url: string; // The URL to make the request to
    method: 'GET' | 'POST' | 'PUT'; // The HTTP method for the request
    headers: { [key: string]: string }; // Optional headers for the request
    data?: string; // Optional data to be sent, can be JSON or XML
    timeout?: number; // Optional timeout parameter in milliseconds

    constructor(url: string, method: 'GET' | 'POST' | 'PUT', headers: { [key: string]: string }, data?: string, timeout?: number) {
        this.url = url;
        this.method = method;
        this.headers = headers;
        this.data = data;
        this.timeout = timeout;
    }

    addHeader(key: string, value: string): void {
        this.headers[key] = value;
    }
}